import { useAppDispatch, useAppSelector } from "./storeHook";
import { useCallback } from "react";
import {
  getDocs,
  getDocById,
  addDoc,
  updateDoc,
  deleteDoc,
  setDocCustomerSelection,
} from "actions/docAction";

export function useDocs() {
  const dispatch = useAppDispatch();
  const { docs, selectedDoc, isLoading, error, selectedCustomerId } = useAppSelector(
    (state: any) => state.doc
  );

  const fetchDocs = useCallback(
    (customerId?: string) => {
      dispatch(getDocs(customerId));
    },
    [dispatch]
  );

  const fetchDocById = useCallback(
    (id: string | number) => {
      dispatch(getDocById(id));
    },
    [dispatch]
  );

  const createDoc = useCallback(
    (doc: any) => {
      dispatch(addDoc(doc));
    },
    [dispatch]
  );

  const updateDocFn = useCallback(
    (doc: any) => {
      dispatch(updateDoc(doc));
    },
    [dispatch]
  );

  const deleteDocFn = useCallback(
    (id: string | number) => {
      dispatch(deleteDoc(id));
    },
    [dispatch]
  );

  const setCustomerSelection = useCallback(
    (customerId: string | null) => {
      dispatch(setDocCustomerSelection(customerId));
    },
    [dispatch]
  );

  return {
    docs,
    selectedDoc,
    isLoading,
    error,
    selectedCustomerId,
    fetchDocs,
    fetchDocById,
    createDoc,
    updateDoc: updateDocFn,
    deleteDoc: deleteDocFn,
    setCustomerSelection,
  };
}

